import { render, staticRenderFns } from "./ExternalContent.vue?vue&type=template&id=1fc4a1c0&scoped=true&"
var script = {}
import style0 from "./ExternalContent.vue?vue&type=style&index=0&id=1fc4a1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc4a1c0",
  null
  
)

export default component.exports